export default __webpack_public_path__ + "translate-chrome-ios-2.png";